import { message, Modal, Col, Row, Card, Table, Empty, Collapse, Checkbox, Button, Tag, Spin, Space } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import dayjs from "dayjs"
import axios from "axios";
// import { HEADERS_BASIC } from "../../../API/apiUrlsGarfe";
import { useEffect, useState } from "react";
// import DetailPayment from "../../detail/DetailPayment";
import { API_DETAIl_CONTRACT, HEADERS_BASIC } from "../../../API/apiUrlsNew";
import { POST_LOAN_DB2_V2 } from "../../../API/apiUrls";
import { ReprintWorkCanCel } from "../report/ReprintWorkCancel";
import { ReprintDemandGuaranter } from "../report/ReprintDemandGuaranter";
import { ReprintLetterCarRepurchase } from "../report/ReprintLetterCarRepurchase";
import DetailPayment from "../../contractDetail/DetailPayment";
import ModalDemandGuaranterHandle from "./modalDemandGuaranterHandle";


const ModalDetailContno = ({ open, close, dataRecord }) => {

    const { Panel } = Collapse;
    const [dataDetail, setDataDetail] = useState({})
    const [loading, setLoading] = useState(false)
    const [dataWCC, setDataWCC] = useState([])
    const [dataWCC_DB2, setDataWCC_DB2] = useState([])
    const [typeDataWccNew, setTypeDataWccNew] = useState(false)
    const [dataTimeWorkCancel, setDataTimeWorkCancel] = useState()
    const [dataTimeDG, setDataTimeDG] = useState()
    // const [modalReprintDemandGuaranter, setModalReprintDemandGuaranter] = useState(false)
    // const [modalReprintWorkCancelContract, setModalReprintWorkCancelContract] = useState(false)
    // const [modalReprintLetterCarRepurchase, setModalReprintLetterCarRepurchase] = useState(false)
    const [selectedReprintDemandGuaranter, setSelectedReprintDemandGuaranter] = useState([]);
    const [selectedReprintWorkCancelContract, setSelectedReprintWorkCancelContract] = useState([]);
    const [selectedReprintLetterCarRepurchase, setSelectedReprintLetterCarRepurchase] = useState([]);

    const [modalDetailPayment, setModalDetailPayment] = useState(false)
    const [modalOpenDemandGuaranterHandle, setModalOpenDemandGuaranterHandle] = useState(false)

    // console.log("dataRecord:", dataRecord);
    // console.log("dataDetail:", dataDetail);
    console.log("dataWCC:", dataWCC);
    console.log("dataWCC_DB2:", dataWCC_DB2);
    // console.log("selectedReprintDemandGuaranter:", selectedReprintDemandGuaranter);
    // console.log("selectedReprintWorkCancelContract:", selectedReprintWorkCancelContract);
    // console.log("selectedReprintLetterCarRepurchase:", selectedReprintLetterCarRepurchase);


    useEffect(() => {
        LoadDetailData()
    }, [])


    const LoadDetailData = async () => {
        setLoading(true)

        await axios.post(API_DETAIl_CONTRACT, { CONTNO: dataRecord.CONTNO, CUSCUD: dataRecord.CUSCOD }, { headers: HEADERS_BASIC })

            .then((res) => {
                // console.log("datadetail", res.data);
                setDataDetail(res.data)

                if (res?.data?.workCancelContractNew.length > 0) {
                    setDataWCC(res?.data?.workCancelContractNew)
                    setDataTimeWorkCancel(res?.data?.workCancelContractNew[0].datetime)
                    handleLoadDataDB2(); // 
                    setTypeDataWccNew(true)
                } else if (res.data.workCancelContractOld.length > 0) {
                    handleLoadDataDB2(); // ถ้ามีในบอกเลิกสัญญาเก่าให้โหลดเอาข้อมูลจาก db2
                    setDataWCC(res?.data?.workCancelContractOld)
                    setDataTimeWorkCancel(res?.data?.workCancelContractOld[0].datetime)
                    setTypeDataWccNew(false)
                } else {
                    setDataWCC([])
                }

                if (res?.data?.logDGMongo.length > 0) {
                    setDataTimeDG(res?.data?.logDGMongo[0].createAt || res?.data?.logDGMongo[0].RoundDate)
                }
                setLoading(false)

            })
            .catch((err) => {
                console.log(err);
                setLoading(false)


            })
    }

    const handleLoadDataDB2 = () => {
        const TYPES = [
            "rpsl",
            "vsfhp",
            "sfhp",
            "lsfhp",
            "psfhp",
            "vsfhp_ksm",
            "tsfhp_ksm",
            "lsfhp_ksm",
        ];

        const buckets = TYPES.reduce((acc, k) => ({ ...acc, [k]: [] }), {});

        [dataRecord].forEach((r) => {
            const type = String(r?.SCHEMA || "").toLowerCase();
            const contno = r?.CONTNO?.trim();
            if (!contno || !TYPES.includes(type)) return;
            if (!buckets[type].includes(contno)) buckets[type].push(contno);
        });

        // แปลงเป็น payload ตามรูป: "'A','B','C'" หรือ "" ถ้าไม่มี
        const payload = TYPES.reduce((acc, k) => {
            acc[k] = buckets[k].length
                ? buckets[k].map((c) => `'${c}'`).join(",")
                : "";
            return acc;
        }, {});

        // console.log("payload", payload);
        queryMultiData(payload);

    }

    const queryMultiData = async (data) => {
        setLoading(true);

        // console.log("queryData ImportData--->", data);
        if (!data || data.length === 0) {
            message.error("ไม่มีข้อมูลสำหรับการค้นหา");
            setLoading(false);
            return;
        }

        await axios.post(POST_LOAN_DB2_V2,
            data,
            { headers: HEADERS_BASIC }
        )
            .then(async (resQuery) => {
                if (resQuery.status === 200) {
                    // console.log("resQuery", resQuery.data);
                    handleExport(resQuery.data);
                    setLoading(false);
                } else {
                    message.error("ไม่มีเลขที่สัญญาที่ค้นหา");
                    console.log("ไม่มีเลขที่สัญญาที่ค้นหา");
                    setLoading(false);
                }
            })
            .catch((err) => {
                console.log(err);
                if (err.status === 404) {
                    message.error("ไม่มีเลขที่สัญญาที่ค้นหา");
                }
            });
    };

    const handleExport = async (rawData) => {
        setLoading(true);

        const useData = mergeDataWithGuarantors(rawData);
        console.log("handleExport", useData);

        setDataWCC_DB2(useData)
        // try {
        //     await PDF_LetterRepurchase(useData);
        //     message.success("โหลด Excel สำเร็จ");
        // } catch (e) {
        //     console.error(e);
        //     message.error(`พิมพ์ไม่สำเร็จ: ${e?.message || "Unknown error"}`);
        // } finally {
        //     setLoading(false);
        // }
    };


    const mergeDataWithGuarantors = (data = []) => {
        // console.log("mergeDataWithGuarantors");

        const rows = data.flatMap((record) => {
            const contno = record?.LOAN?.CONTNO ?? "";
            const dataType = record?.LOAN?.DATA_TYPE ?? "";
            const customer = record?.CUSTOMER ?? {};

            // ที่อยู่ลูกค้าหลัก -> แยกเป็นหลายแถวตาม address
            const custAddresses = Array.isArray(customer.ADDRESS)
                ? customer.ADDRESS
                : customer.ADDRESS
                    ? [customer.ADDRESS]
                    : [];

            const mainData = custAddresses.map((addr) => ({
                ...record,
                cusType: 0,
                CONTNO: contno,
                dataType,
                NAME: `${customer.SNAM ?? ""} ${customer.NAME1 ?? ""} ${customer.NAME2 ?? ""
                    }`
                    .replace(/\s+/g, " ")
                    .trim(),
                ADDRESS: addr || {},
            }));

            // ผู้ค้ำ (ถ้าไม่ใช่ lsfhp)
            let guarantorData = [];
            // if (dataType !== "lsfhp" && Array.isArray(record?.GUARANTORS)) {
                guarantorData = record.GUARANTORS.map((guarantor) => {
                    const addressList = Array.isArray(guarantor.ADDRESS)
                        ? guarantor.ADDRESS
                        : guarantor.ADDRESS
                            ? [guarantor.ADDRESS]
                            : [];
                    // เลือกที่อยู่ตาม ADDRMAIL ไม่เจอให้ใช้ตัวแรก
                    const mainAddress =
                        addressList.find(
                            (addr) => String(addr?.ADDRNO) === String(guarantor?.ADDRMAIL)
                        ) ??
                        addressList[0] ??
                        {};

                    return {
                        ...record,
                        cusType: Number(guarantor?.GARNO) || 0,
                        CONTNO: contno,
                        dataType,
                        NAME: `${guarantor.SNAM ?? ""} ${guarantor.NAME1 ?? ""} ${guarantor.NAME2 ?? ""
                            }`
                            .replace(/\s+/g, " ")
                            .trim(),
                        ADDRESS: mainAddress,
                    };
                });
            // }

            return [...mainData, ...guarantorData];
        });

        console.log('โย่วววววววว');
        
        // ใส่ key ให้แต่ละแถว
        return rows.map((item, index) => ({ ...item, key: index + 1 }));
    };

    const handleCheckDemandGuaranter = (record, checked) => {
        setSelectedReprintDemandGuaranter((prev) => {
            if (checked) {
                // เพิ่มเข้า list
                return [...prev, record];
            } else {
                // เอาออกจาก list
                return prev.filter((i) => i !== record);
            }
        });
    };

    const handleCheckWorkCancelContract = (record, checked) => {
        setSelectedReprintWorkCancelContract((prev) => {
            if (checked) {
                // เพิ่มเข้า list
                return [...prev, record];
            } else {
                // เอาออกจาก list
                return prev.filter((i) => i !== record);
            }
        });
    };

    const handleCheckLetterCarRepurchase = (record, checked) => {
        setSelectedReprintLetterCarRepurchase((prev) => {
            if (checked) {
                // เพิ่มเข้า list
                return [...prev, record];
            } else {
                // เอาออกจาก list
                return prev.filter((i) => i !== record);
            }
        });
    };

    const handlePrintWorkCancel = async () => {
        // setModalReprintWorkCancelContract(true)
        // setSelectedReprintWorkCancelContract([])
        // console.log("selectedReprintWorkCancelContract", selectedReprintWorkCancelContract);

        await ReprintWorkCanCel(selectedReprintWorkCancelContract, typeDataWccNew, dataWCC_DB2, dataTimeWorkCancel)

    }

    const handlePrintDemandGuaranter = async () => {
        // setModalReprintDemandGuaranter(true)
        // setSelectedReprintDemandGuaranter([])
        await ReprintDemandGuaranter(selectedReprintDemandGuaranter, "reprint")

    }
    const handlePrintLetterCarRepurchase = async () => {
        // setModalReprintLetterCarRepurchase(true)
        // setSelectedReprintLetterCarRepurchase([])
        await ReprintLetterCarRepurchase(selectedReprintLetterCarRepurchase)

    }

    const handleDetailPayment = () => {
        setModalDetailPayment(true)
    }
    const listLoneType = {
        HIRE_PURCASE: [1, "ฟ้องเช่าซื้อ"],
        MORTGAGE: [2, "ฟ้องเงินกู้(จดจำนอง)"],
        GENERAL_LOAN: [3, "ฟ้องเงินกู้(กู้ทั่วไป)"],
        CAR_LOAN: [4, "ฟ้องเงินกู้(คู่มือรถ)"],
        DEFFERENCE: [6, "ฟ้องส่วนต่าง"],
        EMBEZZLEMENT: [7, "ฟ้องอาญา(ยักยอกทรัพย์)"],
        FRAUDULENT: [8, "ฟ้องอาญา(ฉ้อโกง)"],
        HIRE_PURCASE_EMBEZZLEMENT: [8, "ฟ้องอาญา(ยักยอกทรัพย์),ฟ้องเช่าซื้อ"],
        MORTGAGE_EMBEZZLEMENT: [9, "ฟ้องอาญา(ยักยอกทรัพย์),ฟ้องเงินกู้"],
    };

    const lawTypeMap = Object.fromEntries(
        Object.values(listLoneType).map(([id, name]) => [id, name])
    );

    const lawTypeColor = {
        1: "blue",
        2: "green",
        3: "purple",
        4: "cyan",
        6: "gold",
        7: "red",
        8: "volcano",
        9: "magenta",
    };

    const handleOpenDemandGuaranterHandle = () => {
        setModalOpenDemandGuaranterHandle(true)
    }


    return (
        <>
            {/* <div>ModalDetailContno</div> */}

            <Modal
                open={open}
                onCancel={close}
                footer={null}
                width={1200}
                maskClosable={false}   // ✅ กันกดข้างนอกแล้วปิด
            >
                <h2 style={{ marginBottom: 16 }}>รายละเอียดสัญญา</h2>
                <Spin spinning={loading} size="large" tip="Loading...">
                    {/* ===== ข้อมูลสัญญาหลัก ===== */}
                    <Card title="ข้อมูลสัญญา" size="small" style={{ marginBottom: 16 }}>
                        <Row gutter={[16, 8]}>
                            <Col span={12}><b>เลขที่สัญญา: <span style={{ color: 'blue' }}>{dataDetail?.CONTNO} </span></b> </Col>

                            <Col span={12}><b>วันที่เริ่มสัญญา:  <span style={{ color: 'red' }}>{dayjs(dataDetail?.SDATE).format("DD-MM-YYYY")}</span> </b></Col>
                            <Col span={12}><b>วันครบสัญญา: <span style={{ color: 'red' }}>{dayjs(dataDetail?.LDATE).format("DD-MM-YYYY")}</span></b> </Col>

                            <Col span={12}><b>ราคาสินเชื่อ: <span style={{ color: 'blue' }}> {dataDetail?.TOTPRC?.toLocaleString()}</span> บาท </b></Col>
                            <Col span={12}><b>ค่างวด: <span style={{ color: 'blue' }}>{dataDetail?.TOT_UPAY?.toLocaleString()} </span> บาท</b> </Col>

                            <Col span={12}><b>จำนวนงวด: <span >{dataDetail?.T_NOPAY} </span></b>  งวด</Col>
                            <Col span={12} style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                <b>ประเภทการฟ้อง:</b>
                                <Tag color={lawTypeColor[dataRecord?.LAW_TYPE_ID] || "orange"}>
                                    {lawTypeMap[dataRecord?.LAW_TYPE_ID] || "ยังไม่มีข้อมูลการฟ้อง"}
                                </Tag>
                            </Col>
                            {/* </Row>
                    <Row gutter={[16, 8]}> */}
                            <Col span={12}>
                                <b>ศาล: <span style={{ color: 'blue' }}>{dataDetail?.workLawsuitNew?.provincialCourt ? dataDetail?.workLawsuitNew?.provincialCourt : '-'}</span></b>
                            </Col>
                            <Col span={12}>
                                <b>
                                    วันประทับฟ้อง:{" "}
                                    <span style={{ color: 'red' }}>
                                        {dataDetail?.workLawsuitNew?.dateOfPlaint &&
                                            dayjs(dataDetail?.workLawsuitNew?.dateOfPlaint).isValid() &&
                                            dayjs(dataDetail?.workLawsuitNew?.dateOfPlaint).year() > 1900
                                            ? dayjs(dataDetail?.workLawsuitNew?.dateOfPlaint).format("DD-MM-YYYY")
                                            : "-"}
                                    </span>
                                </b>
                            </Col>
                            <Col span={24}>
                                <b>เรื่อง: <span style={{ color: 'green' }}>{dataDetail?.workLawsuitNew?.subject ? dataDetail?.workLawsuitNew?.subject : '-'}</span></b>
                            </Col>
                        </Row>
                        <Row gutter={[16, 8]} justify="end" style={{ marginTop: 12 }}>
                            <Col>
                                <Button
                                    type="primary"
                                    onClick={handleDetailPayment}
                                >
                                    การ์ดลูกหนี้
                                </Button>
                            </Col>
                        </Row>
                    </Card>


                    {/* ===== ประวัติการยกเลิกสัญญา ===== */}
                    <Collapse defaultActiveKey={["1", "2", "3"]} style={{ marginBottom: 16 }}>
                        <Panel
                            header={`จดหมายบอกเลิกสัญญา (${dataWCC_DB2?.length})`}
                            key="1"
                        >
                            <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                <Button
                                    style={{ marginBottom: 10 }}
                                    disabled={selectedReprintWorkCancelContract.length === 0}
                                    onClick={handlePrintWorkCancel}
                                    type="primary"
                                >
                                    พิมพ์เอกสาร(Reprint)
                                </Button>
                            </div>
                            <Card size="small">
                                {dataWCC?.length > 0 ? (

                                    <Table
                                        size="small"
                                        tableLayout="fixed"
                                        rowKey="id"
                                        // dataSource={dataDetail?.workCancelContractNew.length > 0 ? dataDetail?.workCancelContractNew : dataWCC_DB2}
                                        dataSource={dataWCC_DB2}
                                        pagination={false}
                                        columns={
                                            // dataDetail?.workCancelContractNew.length > 0 ? // ถ้ามาจากตาราง work_cancle_contract_new จะต้องเอาข้อมูลที่มาจากตารางนั้นมาแปะเลย 
                                            //     [
                                            //         {
                                            //             // title: "ชื่อผู้รับ",
                                            //             width: 40,
                                            //             render: (_, r) => (
                                            //                 <Checkbox
                                            //                     checked={selectedReprintWorkCancelContract.some((i) => i === r)}
                                            //                     onChange={(e) => handleCheckWorkCancelContract(r, e.target.checked)}
                                            //                 >
                                            //                 </Checkbox>
                                            //             ),
                                            //         },
                                            //         { title: "ชื่อผู้รับ", dataIndex: "customerFullName", width: 180 },
                                            //         {
                                            //             title: "ประเภทลูกค้า",
                                            //             dataIndex: "customerTypeId",
                                            //             width: 140,
                                            //             render: (v) => v === 0 ? "ผู้เช่าซื้อ" : `ผู้ค้ำประกัน ${v}`,
                                            //         },
                                            //         {
                                            //             title: "วันที่ออกจดหมาย",
                                            //             dataIndex: "datetime",
                                            //             width: 100,
                                            //             render: (v) =>
                                            //                 v
                                            //                     ?
                                            //                     <Tag color={'orange'}>
                                            //                         <b>{dayjs(v).format("DD-MM-YYYY")}</b>
                                            //                     </Tag>
                                            //                     : "-",
                                            //         },
                                            //         {
                                            //             title: "ที่อยู่",
                                            //             dataIndex: "ADDR",
                                            //             width: 250,
                                            //             // render: (addr) => addr?.ADDR || "-",
                                            //         },
                                            //         {
                                            //             title: "รหัสไปรษณีย์",
                                            //             dataIndex: "zipcode",
                                            //             width: 70,
                                            //             // render: (addr) => addr?.zipcode || "-",
                                            //         },
                                            //     ]
                                            //     : // ถ้ามาจากตาราง work_cancle_contract ข้อมูลจะมาจาก DB2
                                            [
                                                {
                                                    // title: "ชื่อผู้รับ",
                                                    width: 40,
                                                    render: (_, r) => (
                                                        <Checkbox
                                                            checked={selectedReprintWorkCancelContract.some((i) => i === r)}
                                                            onChange={(e) => handleCheckWorkCancelContract(r, e.target.checked)}
                                                        >
                                                        </Checkbox>
                                                    ),
                                                },
                                                { title: "ชื่อผู้รับ", dataIndex: "NAME", width: 180 },
                                                {
                                                    title: "ประเภทลูกค้า",
                                                    dataIndex: "cusType",
                                                    width: 140,
                                                    render: (v) => v === 0 ? "ผู้เช่าซื้อ" : `ผู้ค้ำประกัน ${v}`,
                                                },
                                                {
                                                    title: "วันที่ออกจดหมาย",
                                                    width: 140,
                                                    render: () =>
                                                        dataWCC?.[0]?.datetime
                                                            ?
                                                            <Tag color={'orange'}>
                                                                <b>{dayjs(dataWCC[0].datetime).format("DD-MM-YYYY")}</b>
                                                            </Tag>

                                                            : "-",
                                                },
                                                {
                                                    title: "ที่อยู่",
                                                    dataIndex: "ADDRESS",
                                                    width: 200,
                                                    render: (addr) => addr?.ADDR1 || "-",
                                                },
                                                {
                                                    title: "รหัสไปรษณีย์",
                                                    dataIndex: "ADDRESS",
                                                    width: 70,
                                                    render: (addr) => addr?.ZIP || "-",
                                                },
                                            ]
                                        }
                                    />
                                ) : (
                                    <Empty description="ไม่มีข้อมูล" />
                                )}
                            </Card>
                        </Panel>
                        {/* </Collapse> */}

                        {/* ===== จดหมายบอกกล่าวคนค้ำ ===== */}
                        {/* <Collapse style={{ marginBottom: 16 }}> */}
                        <Panel
                            header={`จดหมายบอกกล่าวคนค้ำ (${dataDetail?.logDGMongo?.length})`}
                            key="2"
                        >
                            <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                <Space>
                                    <Button
                                        style={{ marginBottom: 10 }}
                                        onClick={handleOpenDemandGuaranterHandle}
                                        // disabled={selectedReprintDemandGuaranter.length === 0}
                                        // onClick={handlePrintDemandGuaranter}

                                        danger
                                        type="primary"
                                    >
                                        ออกบอกกล่าวมือ
                                    </Button>

                                    <Button
                                        style={{ marginBottom: 10 }}
                                        disabled={selectedReprintDemandGuaranter.length === 0}
                                        onClick={handlePrintDemandGuaranter}
                                        type="primary"
                                    >
                                        พิมพ์เอกสาร(Reprint)
                                    </Button>
                                </Space>
                            </div>
                            <Card size="small">
                                {dataDetail?.logDGMongo?.length > 0 ? (
                                    <Table
                                        size="small"
                                        tableLayout="fixed"
                                        rowKey={(r, i) => i}
                                        dataSource={dataDetail.logDGMongo}
                                        pagination={false}
                                        columns={[
                                            {
                                                // title: "ชื่อผู้รับ",
                                                width: 40,
                                                render: (_, r) => (
                                                    <Checkbox
                                                        checked={selectedReprintDemandGuaranter.some((i) => i === r)}
                                                        onChange={(e) => handleCheckDemandGuaranter(r, e.target.checked)}
                                                        disabled={!r.RoundDate}
                                                    >
                                                    </Checkbox>
                                                ),
                                            },
                                            {
                                                title: "ชื่อผู้รับ",
                                                width: 180,
                                                render: (_, r) => {
                                                    const name = `${r?.SNAM || ""}${r?.NAME1 || ""} ${r?.NAME2 || ""}`.trim()

                                                    return name ? name : "-"
                                                },
                                            },
                                            {
                                                title: "ประเภทลูกค้า",
                                                dataIndex: "GARNO",
                                                width: 140,
                                                render: (v) => v ? `ผู้ค้ำประกัน ${v}` : "-",
                                            },
                                            {
                                                title: "งวดที่",
                                                dataIndex: "NOPAY",
                                                width: 80,
                                                // render: (v) => `ผู้ค้ำประกัน ${v}`,
                                            },
                                            {
                                                title: "รอบออกจดหมาย",
                                                width: 140,
                                                align: "center",
                                                render: (_, record) => {

                                                    const dateValue =
                                                        record?.createAt ||
                                                        // record?.createdAt ||
                                                        record?.RoundDate
                                                    // record?.DUEDATE

                                                    return dateValue ? (
                                                        <Tag color="orange">
                                                            <b>{dayjs(dateValue).format("DD-MM-YYYY")}</b>
                                                        </Tag>
                                                    ) : "-"
                                                },
                                            },
                                            {
                                                title: "ที่อยู่",
                                                width: 200,
                                                render: (_, r) => r.ADDR1 || "-",
                                            },
                                            {
                                                title: "รหัสไปรษณีย์",
                                                width: 70,
                                                render: (_, r) => r.ZIP || "-",
                                            },
                                        ]}
                                    />
                                ) : (
                                    <Empty description="ไม่มีข้อมูล" />
                                )}
                            </Card>
                        </Panel>
                        {/* </Collapse> */}

                        {/* ===== จดหมายซื้อรถคืน / รถยึด ===== */}
                        {
                            dataRecord.SCHEMA !== `lsfhp` ?

                                // <Collapse>
                                <Panel
                                    header={`จดหมายซื้อรถคืน (${dataDetail?.letterCarRepurchase?.length})`}
                                    key="3"
                                >
                                    <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                        <Button
                                            style={{ marginBottom: 10 }}
                                            disabled={selectedReprintLetterCarRepurchase.length === 0}
                                            onClick={handlePrintLetterCarRepurchase}
                                            type="primary"
                                        >
                                            พิมพ์เอกสาร(Reprint)
                                        </Button>
                                    </div>
                                    <Card size="small">
                                        {dataDetail?.letterCarRepurchase?.length > 0 ? (
                                            <Table
                                                size="small"
                                                tableLayout="fixed"
                                                rowKey={(r, i) => i}
                                                dataSource={dataDetail.letterCarRepurchase}
                                                pagination={false}
                                                columns={[
                                                    {
                                                        // title: "ชื่อผู้รับ",
                                                        width: 40,
                                                        render: (_, r) => (
                                                            <Checkbox
                                                                checked={selectedReprintLetterCarRepurchase.some((i) => i === r)}
                                                                onChange={(e) => handleCheckLetterCarRepurchase(r, e.target.checked)}
                                                            >
                                                            </Checkbox>
                                                        ),
                                                    },
                                                    { title: "ชื่อผู้รับ", dataIndex: "CNAME", width: 180 },
                                                    {
                                                        title: "ประเภทลูกค้า",
                                                        dataIndex: "cusType",
                                                        width: 140,
                                                        render: (v) => v === 0 ? "ผู้เช่าซื้อ" : `ผู้ค้ำประกัน ${v}`,
                                                    },

                                                    {
                                                        title: "วันที่ออกจดหมาย",
                                                        dataIndex: "SendDate",
                                                        width: 160,
                                                        align: "center",
                                                        render: (v) =>
                                                            v ?
                                                                <Tag color="success">
                                                                    <b>{dayjs(v).format("DD-MM-YYYY")}</b>
                                                                </Tag>
                                                                :
                                                                "-",

                                                    },
                                                    {
                                                        title: "ที่อยู่",
                                                        width: 200,
                                                        render: (_, r) => r.ADDR || "-",
                                                    },
                                                    {
                                                        title: "รหัสไปรษณีย์",
                                                        width: 70,
                                                        render: (_, r) => r.ZIP || "-",
                                                    },
                                                ]}
                                            />
                                        ) : (
                                            <Empty description="ไม่มีข้อมูล" />
                                        )}
                                    </Card>
                                </Panel>
                                : null
                        }
                    </Collapse>

                    <Row justify="end" style={{ margin: 20 }}>
                        <Button
                            danger
                            icon={<CloseOutlined />}
                            onClick={close}
                            style={{
                                borderRadius: 8,
                                fontWeight: 500,

                            }}
                        >
                            ปิด
                        </Button>
                    </Row>
                </Spin>

            </Modal>
            {
                modalOpenDemandGuaranterHandle && (
                    <ModalDemandGuaranterHandle
                        open={modalOpenDemandGuaranterHandle}
                        close={setModalOpenDemandGuaranterHandle}
                        dataRecord={dataRecord}
                        fetchData={LoadDetailData}
                    />
                )
            }


            {/* {
                modalReprintDemandGuaranter ?
                    <ReprintDemandGuaranter
                        open={modalReprintDemandGuaranter}
                        dataReprintDemandGuaranter={selectedReprintDemandGuaranter}

                    />
                    : null
            }
            {
                modalReprintWorkCancelContract ?
                    <ReprintWorkCanCel
                        open={modalReprintWorkCancelContract}
                        dataReprintWorkCancelContractOld={selectedReprintWorkCancelContract}


                    />
                    : null
            }
            {
                modalReprintLetterCarRepurchase ?
                    <ReprintLetterCarRepurchase
                        open={modalReprintLetterCarRepurchase}
                        dataReprintLetterCarRepurchase={selectedReprintLetterCarRepurchase}

                    />
                    : null
            } */}



            <Modal
                open={modalDetailPayment}
                onCancel={() => setModalDetailPayment(false)}
                footer={null}
                width={1000}
            >
                <DetailPayment
                    dataRecord={dataRecord}
                    schemaContract={dataRecord.SCHEMA}
                    page={'DetailContno'}
                    dataTimeWorkCancel={dataTimeWorkCancel}
                    dataTimeDG={dataTimeDG}
                />
            </Modal>



        </>
    )
}

export default ModalDetailContno;